import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker", "text"]

  connect() {
    // Remove name from picker so only the text field submits
    this.pickerTarget.removeAttribute("name")
  }

  pickerChanged() {
    this.textTarget.value = this.pickerTarget.value.toUpperCase()
  }

  textChanged() {
    const value = this.textTarget.value
    if (/^#[0-9A-Fa-f]{6}$/.test(value)) {
      this.pickerTarget.value = value
    }
  }
}
